import React from 'react'
import FooterWidgetComponent from '../../widgets/FooterWidget/FooterWidgetComponent'
import SectionAComponent from './widget/SectionA/SectionAComponent'
import FaqsBannerComponent from './widget/FaqsBanner/FaqsBannerComponent'

function Faqs() {
  return (
    <div>
        <FaqsBannerComponent/>
        <SectionAComponent/>
        <FooterWidgetComponent/>
    </div>
  )
}

export default Faqs